import React from "react";

const GlobalProvider: React.FC = ({ children }) => {
  return <>{children}</>;
};

export default GlobalProvider;
